import { useMutation } from "@apollo/client";
import { registerServiceBundleMutation } from "../../container/AllServiceBundleView";
export const useRegisterServiceBundle = (url, envId) => {
    const [registerServiceBundle] = useMutation(registerServiceBundleMutation, {
        variables: { url, envName: envId },
    });
    return registerServiceBundle;
};
